import { GroupStatusTypes } from "interfaces";
import { SearchIcon } from "@heroicons/react/outline";
import Button from "components/button";
import { Label } from "components/label";
import Input from "components/input";
import Select from "components/select";

export interface FilterType {
  page: number;
  name_en: string;
  event_id: string;
  order_status: string;
}

export const ORDER_STATUS_OPTIONS = [
  { value: "", label: "All", color: "" },
  { value: "1", label: "Opening", color: GroupStatusTypes.OPENING },
  {
    value: "2",
    label: "Send payment",
    color: GroupStatusTypes.SENDPAYMENT,
  },
  { value: "3", label: "Closed", color: GroupStatusTypes.CLOSED },
  { value: "4", label: "Success", color: GroupStatusTypes.SUCCESS },
  { value: "0", label: "Canceled", color: GroupStatusTypes.CANCELED },
];

interface PropType {
  eventOptions: {
    value: string;
    label: string;
  }[];
  filter: FilterType;
  handleChangeFilter: (key: string, value: string, value2?: string) => void;
  onSubmit: (data: FilterType) => void;
}

const FilterBar = (props: PropType) => {
  const { eventOptions, filter, handleChangeFilter, onSubmit } = props;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(filter);
  };

  return (
    <form
      className="box-container w-full flex flex-wrap items-end gap-3"
      onSubmit={(e) => {
        handleSubmit(e);
      }}
    >
      <div className="w-full md:w-[400px]">
        <Label id="search" name="Search" />
        <div className="mt-2">
          <Input
            className="px-2 py-2"
            label="Search"
            id="search"
            type="text"
            placeholder="Search by Group Name"
            value={filter.name_en}
            onChange={(e: any) => {
              handleChangeFilter("name_en", e.target.value);
            }}
          />
        </div>
      </div>

      <div className="w-full md:w-[400px]">
        <Label id="event_id" name="Event" />
        <div className="mt-2">
          <Select
            options={eventOptions}
            isClearable={true}
            id="event_id"
            placeholder="Select option"
            className="py-0.5"
            value={eventOptions?.find((d) => d?.value === filter.event_id)}
            onChange={(selected: { label: string; value: string }) => {
              handleChangeFilter("event_id", selected?.value ?? "");
            }}
          />
        </div>
      </div>

      <div className="w-[200px]">
        <Label id="order_status" name="Status" />
        <div className="mt-2">
          <Select
            options={ORDER_STATUS_OPTIONS}
            isClearable={true}
            id="order_status"
            placeholder="Select option"
            className="py-0.5"
            value={ORDER_STATUS_OPTIONS.find(
              (d) => d.value === filter.order_status
            )}
            onChange={(selected: { label: string; value: string }) => {
              handleChangeFilter("order_status", selected?.value ?? "");
            }}
          />
        </div>
      </div>

      <Button
        type="submit"
        className="w-[100px] bg-white rounded-md px-3 text-brand-500 py-2
                        border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85"
      >
        <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> Search
      </Button>
    </form>
  );
};

export default FilterBar;
